module.exports = __webpack_public_path__ + "static/img/slogan.9642c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slogan.png
// module id = iQy/
// module chunks = 1